import { Card, Center, HStack, Spinner, VStack } from '@chakra-ui/react';
import { NewsBannerItemFragment } from '@client/graphql/types/graphql';
import ApplicationErrorView from '@client/module/error/application-error-view';
import { useFocusedCompanyContext } from '@packages/core/company/focused-company-context';
import { useTranslate } from '@tolgee/react';
import NewsBannerCreateModal from './components/news-banner/news-banner-create-modal';
import NewsBannerTable from './components/news-banner/news-banner-table';
import { useNewsBanners } from './logics/news-banner/use-news-banners';

export default function NewsBanner() {
  const { t } = useTranslate();
  const company = useFocusedCompanyContext();
  const { data, loading, error } = useNewsBanners(company.id);

  if (loading) {
    return (
      <Center>
        <Spinner />
      </Center>
    );
  }

  // Map data.newsBanners to NewsBannerItemFragment[]
  const banners: NewsBannerItemFragment[] = (data?.newsBanners ?? []) as unknown as NewsBannerItemFragment[];

  return (
    <Card.Root maxW="5xl" rounded="lg" shadow={'xs'}>
      <Card.Header borderBottom="1px solid" borderColor="gray.200" py="5">
        <HStack justify="space-between" align="start">
          <VStack align="start" gap={'4'}>
            <Card.Title fontSize="2xl" fontWeight="bold" color="gray.800">
              {t('news-banner.title', 'News Banner')}
            </Card.Title>
          </VStack>
          <NewsBannerCreateModal />
        </HStack>
      </Card.Header>
      <Card.Body p={0}>
        <ApplicationErrorView error={error} />
        <NewsBannerTable banners={banners} />
      </Card.Body>
    </Card.Root>
  );
}
